import React, { useEffect, useState } from "react";
import { Button, Tooltip, Avatar, Popover, Divider } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { getEffectivePagePath } from "@/utils";
import { getAppInfo } from "@/services";
import { getUserInfo } from "@yuntoo/user";

// import styles from "./index.module.css";

export default function AdminSlot() {
  const [appInfo, setAppInfo] = useState(null);
  const userInfo = getUserInfo();
  const { id: userId } = userInfo;

  useEffect(() => {
    getAppInfo().then((res) => {
      setAppInfo(res);
    });
  }, []);

  // 非创建者不可见
  if (userId !== appInfo?.createUserId) return null;

  return (
    <Tooltip
      placement="bottomRight"
      title={"这是您创建的应用，可以点击管理（其他用户不可见）"}
      arrow
    >
      <Button
        size="large"
        type="text"
        shape="circle"
        icon={<SettingOutlined />}
        onClick={() => {
          const pagePath = getEffectivePagePath(); // 获取有效的页面path e.g. /xxxxx
          // TODO: 更新为真实的线上域名
          window.open(
            `https://app.lovrabet.com/web-app/1.0.1-beta.6/app/${appInfo?.appCode}/pages${pagePath}`,
          );
        }}
      />
    </Tooltip>
  );
}
